import { useEffect, useState } from "react";

export default function Countdown({ target, onExpire, testId }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const end = new Date(target).getTime();
  const diff = Math.max(0, end - now);
  const expired = diff <= 0;
  useEffect(() => {
    if (expired && onExpire) onExpire();
  }, [expired, onExpire]);
  const secs = Math.floor(diff / 1000);
  const d = Math.floor(secs / 86400);
  const h = Math.floor((secs % 86400) / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  const parts = [];
  if (d) parts.push(`${d}d`);
  parts.push(`${String(h).padStart(2, "0")}h`);
  parts.push(`${String(m).padStart(2, "0")}m`);
  parts.push(`${String(s).padStart(2, "0")}s`);
  return (
    <span data-testid={testId} className="font-fredoka tabular-nums">
      {expired ? "Closed" : parts.join(" ")}
    </span>
  );
}
